import { render, staticRenderFns } from "./input-large.html?vue&type=template&id=63c0bf50&scoped=true&"
import script from "./input-large.js?vue&type=script&lang=js&"
export * from "./input-large.js?vue&type=script&lang=js&"
import style0 from "./input-large.scss?vue&type=style&index=0&id=63c0bf50&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c0bf50",
  null
  
)

export default component.exports